import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export const STEPS = [
	{ label: 'Select Plan', path: '/subscription-plan' },
	{ label: 'Billing Details', path: '/checkout' },
	{ label: 'Make Payment', path: '/payment' },
];

export const useStepper = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const selectedPlan = useSelector((state) => state.subscription.selectedPlan);
	const billingValid = useSelector((state) => state.checkout.billingValid);

	// current step based on route
	const currentStep = useMemo(() => {
		return STEPS.findIndex((step) => step.path === location.pathname);
	}, [location.pathname]);

	const goToStep = (index) => {
		const target = STEPS[index];

		// prevent same route navigation
		if (location.pathname === target.path) return;

		// 🔒 guard: must select plan
		if (index >= 1 && !selectedPlan) {
			navigate('/subscription-plan');
			return;
		}

		// 🔒 guard: must fill billing
		if (index >= 2 && !billingValid) {
			navigate('/checkout');
			return;
		}

		navigate(target.path);
	};

	return {
		steps: STEPS,
		currentStep,
		goToStep,
	};
};
